import { Chip, ChipProps } from '@mui/material';

import { styled } from '../../styles';

export const ChipStyled = styled(Chip)<ChipProps>(({ size, theme }) => ({
  paddingTop: size === 'small' ? theme.spacing(0.5) : theme.spacing(1),
  paddingBottom: size === 'small' ? theme.spacing(0.5) : theme.spacing(1),
}));
